var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowcaseWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.71484V9.14342",
    stroke: "#E50347",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00014 13.1429C8.31573 13.1429 8.57157 12.887 8.57157 12.5714C8.57157 12.2558 8.31573 12 8.00014 12C7.68455 12 7.42871 12.2558 7.42871 12.5714C7.42871 12.887 7.68455 13.1429 8.00014 13.1429Z",
    stroke: "#E50347",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01696 1.19988C8.92106 1.01268 8.77535 0.85558 8.59588 0.745876C8.41642 0.636173 8.21016 0.578125 7.99982 0.578125C7.78948 0.578125 7.58322 0.636173 7.40376 0.745876C7.22429 0.85558 7.07858 1.01268 6.98268 1.19988L0.696963 13.7713C0.609294 13.9453 0.567555 14.1388 0.575709 14.3334C0.583862 14.5281 0.641638 14.7174 0.743549 14.8834C0.845461 15.0495 0.988124 15.1867 1.15799 15.2821C1.32786 15.3775 1.51929 15.4279 1.71411 15.4285H14.2855C14.4804 15.4279 14.6718 15.3775 14.8416 15.2821C15.0115 15.1867 15.1542 15.0495 15.2561 14.8834C15.358 14.7174 15.4158 14.5281 15.4239 14.3334C15.4321 14.1388 15.3903 13.9453 15.3027 13.7713L9.01696 1.19988Z",
    stroke: "#E50347",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowcaseWarning);
export default __webpack_public_path__ + "static/media/showcase-warning.e8c2eb1d.svg";
export { ForwardRef as ReactComponent };